enum NotificationPermission {
    DEFAULT = 'default',
    GRANTED = 'granted',
    DENIED = 'denied'
}

export default NotificationPermission;
